import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Categories from '../../../components/CategoriesAutocomplete';
import DraftCategories from '../../../components/PostDraft/DraftCategories';
import { EditDraftForm } from '../../../components/PostDraft/EditDraftFormRender';
import PostDraftComponent from '../../../components/PostDraft/PostDraft.component';
import { SimpleDialog } from '../../../components/UI/SimpleDialog';
import { POST } from '../../../constants/post.constants';
import { useDrafts } from '../../../hooks/useDrafts';
import type { PostDraftInterface } from '../../../interfaces/post.interface';
import type { UserState } from '../../../interfaces/user.interface';
import { draftSlice } from '../../../store/draft.store';
import './draft.scss';

export default function PostDraft() {
  const params = useParams();
  const { draftId } = params;
  const dispatch = useDispatch();
  const { user } = useSelector((state: UserState) => state.userStore);
  const username = user?.username;
  const { getDraftById } = useDrafts(user?.id);
  const { draft, refreshDraft } = useSelector((state: any) => state.draftStore);
  const { id } = user;
  const [postDraft, setPostDraft] = useState<
    PostDraftInterface | Record<any, any>
  >({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    GET_DRAFT_STORE_ACTION,
    IS_EDITING_DRAFT_STORE_ACTION,
    REFRESH_DRAFT_STORE_ACTION,
  } = draftSlice.actions;

  useEffect(() => {
    const found = getDraftById(draftId as string);
    if (found) {
      dispatch(GET_DRAFT_STORE_ACTION(found));
      setPostDraft(found);
    }
  }, [draftId, getDraftById]);

  useEffect(() => {
    if (refreshDraft) {
      setPostDraft(draft);
      dispatch(REFRESH_DRAFT_STORE_ACTION(false));
    }
  }, [refreshDraft, draft]);

  const handleEditDraft = (event: React.SyntheticEvent, id: string) => {
    setIsModalOpen(true);
    dispatch(IS_EDITING_DRAFT_STORE_ACTION(true));
  };

  const handleClose = () => {
    dispatch(IS_EDITING_DRAFT_STORE_ACTION(false));
    setIsModalOpen(false);
  };

  const draftPostRender = draft && (
    <>
      <div className="DRAFT">
        <div className="DRAFT__CATEGORIES__ROW">
          <Categories
            draftId={draftId as string}
            selectedCategories={draft.categories}
          />
          <DraftCategories draftId={draftId as string} />
        </div>
        <div className="DRAFT__CONTAINER">
          <PostDraftComponent
            username={username as string}
            userId={id as string}
            onEditDraft={() =>
              handleEditDraft({} as React.SyntheticEvent, draftId as string)
            }
          />
        </div>
      </div>
      <SimpleDialog
        fullWidth
        className="Simple-Dialog-From-Text-Editor"
        closeModalLabel={POST.CANCEL}
        dialogBody={<EditDraftForm handleClose={handleClose} />}
        dialogTitle={POST.EDIT_DRAFT}
        maxWidth="lg"
        open={isModalOpen}
        textEditor={true}
        onClose={handleClose}
      />
    </>
  );
  return draftPostRender;
}
